import React from 'react';

export const CarIcon = () => (
  <svg height="35" viewBox="0 0 44.7 39.956" width="40" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M40.766,7.4A3.544,3.544,0,0,0,37.4,5H11.3A3.567,3.567,0,0,0,7.934,7.4L3,21.606V40.583a2.379,2.379,0,0,0,2.372,2.372H7.744a2.379,2.379,0,0,0,2.372-2.372V38.211H38.583v2.372a2.379,2.379,0,0,0,2.372,2.372h2.372A2.379,2.379,0,0,0,45.7,40.583V21.606ZM11.3,31.094a3.558,3.558,0,1,1,3.558-3.558A3.554,3.554,0,0,1,11.3,31.094Zm26.094,0a3.558,3.558,0,1,1,3.558-3.558A3.554,3.554,0,0,1,37.4,31.094ZM7.744,19.233,11.3,8.558H37.4l3.558,10.675Z"
      fill="none"
      id="ic_directions_car_24px"
      stroke="rgba(10,50,86,0.7)"
      strokeWidth="2"
      transform="translate(-2 -4)"
    />
  </svg>
);
